import type { Dayjs } from 'dayjs';
import { useMemo } from 'react';

import Typo from '@/components/Typography/Typo';
import { CUSTOMER_QUERY_DATE_RANGE } from '@/types/customerConst';
import { DATE_FORMAT } from '@/utils/time';

import CustomerTableStyles from './CustomerTableStyles';

type ChartLabelsProps = {
  startDate: Dayjs;
  endDate: Dayjs;
  dateRange: CUSTOMER_QUERY_DATE_RANGE;
  offset: number;
};
const { StyledChartLabels } = CustomerTableStyles;
export const SENTIMENT_CHART_OFFSET = 24;

const ChartLabels = (props: ChartLabelsProps) => {
  // Calculate the difference in days
  const daysDifference = props.endDate.diff(props.startDate, 'day');

  // Generate an array of dates
  const datesArray = Array.from({ length: daysDifference + 1 }, (_, index) => {
    return props.startDate.addVal(index, 'day');
  });

  const selectedLabels = useMemo(() => {
    switch (props.dateRange) {
      case CUSTOMER_QUERY_DATE_RANGE.DAY1:
        return datesArray;
      case CUSTOMER_QUERY_DATE_RANGE.DAY7:
        return datesArray.filter((date, index) => index % 2 === 0);
      case CUSTOMER_QUERY_DATE_RANGE.DAY30:
        return datesArray.filter((date, index) => index % 7 === 0);
      case CUSTOMER_QUERY_DATE_RANGE.DAY90:
        return datesArray.filter((date, index) => index % 15 === 0);
      default:
        return datesArray;
    }
  }, [datesArray, props.dateRange]);

  const getLabelPosition = (currentDate: Dayjs) => {
    const totalDuration = props.endDate.diff(props.startDate, 'second');
    const currentDuration = currentDate.diff(props.startDate, 'second');

    return (currentDuration / totalDuration) * 100;
  };

  return (
    <StyledChartLabels offset={props?.offset || 16}>
      <div className="labels-wrapper">
        {selectedLabels.map((label, index) => {
          const date =
            label.month() === 0
              ? label.format(DATE_FORMAT.readable)
              : label.format(DATE_FORMAT.short);

          return (
            <Typo
              key={date + index}
              type="label3"
              weight="r"
              className="label text-gray-600"
              style={{
                left: `${getLabelPosition(label)}%`,
              }}
            >
              {date}
            </Typo>
          );
        })}
      </div>
    </StyledChartLabels>
  );
};

export default ChartLabels;
